import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = chargement, null = non connecté

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      // ignore
    }
    setUser(null);
  }, []);

  const hasRole = useCallback(
    (...roles) => !!user && roles.some((r) => (user.roles || []).includes(r)),
    [user]
  );

  return (
    <AuthContext.Provider value={{ user, setUser, logout, hasRole, refresh: check }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function homePathFor(user) {
  const roles = user?.roles || [];
  if (roles.includes("admin") || roles.includes("super_admin")) return "/admin";
  if (roles.includes("comptable")) return "/comptabilite";
  if (roles.includes("eveque")) return "/arbitrage";
  if (roles.includes("valideur")) return "/validation";
  return "/accueil";
}
